import { render, staticRenderFns } from "./FlowDesignForm.vue?vue&type=template&id=77d3bf9e&scoped=true"
import script from "./FlowDesignForm.vue?vue&type=script&lang=js"
export * from "./FlowDesignForm.vue?vue&type=script&lang=js"
import style0 from "./FlowDesignForm.vue?vue&type=style&index=0&id=77d3bf9e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3bf9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d3bf9e')) {
      api.createRecord('77d3bf9e', component.options)
    } else {
      api.reload('77d3bf9e', component.options)
    }
    module.hot.accept("./FlowDesignForm.vue?vue&type=template&id=77d3bf9e&scoped=true", function () {
      api.rerender('77d3bf9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/workflow/FlowDesignForm.vue"
export default component.exports